import { render, staticRenderFns } from "./CustomerCard.vue?vue&type=template&id=36bbfaa7&scoped=true"
import script from "./CustomerCard.vue?vue&type=script&lang=js"
export * from "./CustomerCard.vue?vue&type=script&lang=js"
import style0 from "./CustomerCard.vue?vue&type=style&index=0&id=36bbfaa7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bbfaa7",
  null
  
)

export default component.exports